module.exports = __webpack_public_path__ + "static/affiliate/affiliate-square_ski-bro2--swiss-6399588f861a0b636d8ede2f8e66004b.jpg";